import Badge from 'components/base/Badge';
import OrderInfoItem from 'components/info-items/OrderInfoItem';
import { Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

interface AddressProps {
  street: string;
  city: string;
  state: string;
  country: string;
  postalCode: string;
  phone: string;
}

interface BillingDetailsProps {
  billingAddress: AddressProps;
}

interface ShippingDetailsProps {
  shippingAddress: AddressProps;
}

interface OtherDetailsProps {
  paymentStatus: string;
  fulfillmentStatus: string;
  deliveryStatus: string;
}

export const BillingDetails = ({ billingAddress }: BillingDetailsProps) => {
  return (
    <>
      <h4 className="mb-5">Billing details</h4>
      <Row className="g-4 flex-sm-column">
        {/* <Col xs={6} sm={12}>
          <OrderInfoItem icon="user" label="Customer" />
          <Link className="fs-9 ms-4" to="#!">
            {fullName}
          </Link>
        </Col> */}
        <Col xs={6} sm={12}>
          <OrderInfoItem icon="phone" label="Phone" />
          <Link className="fs-9 ms-4" to={`tel:${billingAddress.phone}`}>
            {billingAddress.phone}
          </Link>
        </Col>
        <Col xs={6} sm={12}>
          <OrderInfoItem icon="home" label="Address" />
          <div className="ms-4">
            <p className="text-body-secondary mb-0 fs-9">
              {billingAddress.street}
            </p>
            <p className="text-body-secondary mb-0 fs-9">
              {billingAddress.city}, {billingAddress.state},
              <br className="d-none d-sm-block" />
              {billingAddress.country}
            </p>
          </div>
        </Col>
      </Row>
    </>
  );
};

export const ShippingDetails = ({ shippingAddress }: ShippingDetailsProps) => {
  return (
    <>
      <h4 className="mb-5">Shipping details</h4>
      <Row className="g-4 flex-sm-column">
        {/* <Col xs={6} sm={12}>
          <OrderInfoItem icon="user" label="Customer" />
          <Link className="fs-9 ms-4" to="#!">
            {fullName}
          </Link>
        </Col> */}
        <Col xs={6} sm={12}>
          <OrderInfoItem icon="phone" label="Phone" />
          <Link className="fs-9 ms-4" to={`tel:${shippingAddress.phone}`}>
            {shippingAddress.phone}
          </Link>
        </Col>
        {/* <Col xs={6} sm={12}>
          <OrderInfoItem icon="calendar" label="Shipping Date" />
          <p className="mb-0 text-body-secondary fs-9 ms-4">12 Nov, 2021</p>
        </Col> */}
        <Col xs={6} sm={12}>
          <OrderInfoItem icon="home" label="Address" />
          <div className="ms-4">
            <p className="text-body-secondary mb-0 fs-9">
              {shippingAddress.street}
            </p>
            <p className="text-body-secondary mb-0 fs-9">
              {shippingAddress.city}, {shippingAddress.state},
              <br className="d-none d-sm-block" />
              {shippingAddress.country}
            </p>
          </div>
        </Col>
      </Row>
    </>
  );
};

export const OtherDetails = ({
  paymentStatus,
  fulfillmentStatus,
  deliveryStatus
}: OtherDetailsProps) => {
  return (
    <>
      <h4 className="mb-5">Other details</h4>
      <Row className="g-4 flex-sm-column">
        <Col xs={6} sm={12}>
          <OrderInfoItem icon="credit-card" label="Payment status" />
          <Badge
            bg={
              paymentStatus === 'paid'
                ? 'success'
                : paymentStatus === 'pending' || paymentStatus === 'processing'
                ? 'warning'
                : paymentStatus === 'refunded'
                ? 'danger'
                : 'secondary'
            }
            variant="phoenix"
            className="text-uppercase ms-4"
          >
            {paymentStatus}
          </Badge>
        </Col>
        <Col xs={6} sm={12}>
          <OrderInfoItem icon="package" label="Fullfillment status" />
          <Badge
            bg={
              fulfillmentStatus === 'fulfilled'
                ? 'success'
                : fulfillmentStatus === 'unfulfilled'
                ? 'danger'
                : 'warning'
            }
            variant="phoenix"
            className="text-uppercase ms-4"
          >
            {fulfillmentStatus}
          </Badge>
        </Col>
        <Col xs={6} sm={12}>
          <OrderInfoItem icon="truck" label="Delivery status" />
          <Badge
            bg={
              deliveryStatus === 'delivered'
                ? 'success'
                : deliveryStatus === 'cancelled'
                ? 'danger'
                : 'warning'
            }
            variant="phoenix"
            className="text-uppercase ms-4"
          >
            {deliveryStatus}
          </Badge>
        </Col>
      </Row>
    </>
  );
};
